import { defineComponent as Q, h as o, computed as _ } from "vue";
import { dialogProps as U } from "./highrise1180.mjs";
import X from "./highrise1181.mjs";
import Y from "./highrise1104.mjs";
import { resolveWrappedSlot as z, resolveSlot as T } from "./highrise1059.mjs";
import { render as a } from "./highrise1182.mjs";
import S from "./highrise441.mjs";
import Z from "./highrise1081.mjs";
import ee from "./highrise1053.mjs";
import { useRtl as oe } from "./highrise1067.mjs";
import k from "./highrise984.mjs";
import te from "./highrise998.mjs";
import { createKey as ie } from "./highrise314.mjs";
import { getMargin as ne } from "./highrise1080.mjs";
import { useThemeClass as le } from "./highrise1062.mjs";
import se from "./highrise1133.mjs";
import re from "./highrise1134.mjs";
import ce from "./highrise1136.mjs";
import B from "./highrise1135.mjs";
const ae = {
  default: () => o(B, null),
  info: () => o(B, null),
  success: () => o(ce, null),
  warning: () => o(re, null),
  error: () => o(se, null)
}, Se = Q({
  name: "Dialog",
  alias: [
    "NimbusConfirmCard",
    // deprecated
    "Confirm"
    // deprecated
  ],
  props: Object.assign(Object.assign({}, k.props), U),
  slots: Object,
  setup(n) {
    const {
      mergedComponentPropsRef: d,
      mergedClsPrefixRef: c,
      inlineThemeDisabled: h,
      mergedRtlRef: x
    } = ee(n), m = oe("Dialog", x, c), g = _(() => {
      var t, i;
      const {
        iconPlacement: r
      } = n;
      return r || ((i = (t = d == null ? void 0 : d.value) === null || t === void 0 ? void 0 : t.Dialog) === null || i === void 0 ? void 0 : i.iconPlacement) || "left";
    });
    function y(t) {
      const {
        onPositiveClick: i
      } = n;
      i && i(t);
    }
    function f(t) {
      const {
        onNegativeClick: i
      } = n;
      i && i(t);
    }
    function R() {
      const {
        onClose: t
      } = n;
      t && t();
    }
    const u = k("Dialog", "-dialog", X, te, n, c), v = _(() => {
      const {
        type: t
      } = n, i = g.value, {
        common: {
          cubicBezierEaseInOut: r
        },
        self: {
          fontSize: p,
          lineHeight: C,
          border: e,
          titleTextColor: b,
          textColor: $,
          color: l,
          closeBorderRadius: P,
          closeColorHover: M,
          closeColorPressed: O,
          closeIconColor: N,
          closeIconColorHover: D,
          closeIconColorPressed: E,
          closeIconSize: j,
          borderRadius: H,
          titleFontWeight: w,
          titleFontSize: V,
          padding: W,
          iconSize: F,
          actionSpace: K,
          contentMargin: L,
          closeSize: q,
          [i === "top" ? "iconMarginIconTop" : "iconMargin"]: A,
          [i === "top" ? "closeMarginIconTop" : "closeMargin"]: G,
          [ie("iconColor", t)]: J
        }
      } = u.value, I = ne(A);
      return {
        "--n-font-size": p,
        "--n-icon-color": J,
        "--n-bezier": r,
        "--n-close-margin": G,
        "--n-icon-margin-top": I.top,
        "--n-icon-margin-right": I.right,
        "--n-icon-margin-bottom": I.bottom,
        "--n-icon-margin-left": I.left,
        "--n-icon-size": F,
        "--n-close-size": q,
        "--n-close-icon-size": j,
        "--n-close-border-radius": P,
        "--n-close-color-hover": M,
        "--n-close-color-pressed": O,
        "--n-close-icon-color": N,
        "--n-close-icon-color-hover": D,
        "--n-close-icon-color-pressed": E,
        "--n-color": l,
        "--n-text-color": $,
        "--n-border-radius": H,
        "--n-padding": W,
        "--n-line-height": C,
        "--n-border": e,
        "--n-content-margin": L,
        "--n-title-font-size": V,
        "--n-title-font-weight": w,
        "--n-title-text-color": b,
        "--n-action-space": K
      };
    }), s = h ? le("dialog", _(() => `${n.type[0]}${g.value[0]}`), v, n) : void 0;
    return {
      mergedClsPrefix: c,
      rtlEnabled: m,
      mergedIconPlacement: g,
      mergedTheme: u,
      handlePositiveClick: y,
      handleNegativeClick: f,
      handleCloseClick: R,
      cssVars: h ? void 0 : v,
      themeClass: s == null ? void 0 : s.themeClass,
      onRender: s == null ? void 0 : s.onRender
    };
  },
  render() {
    var n;
    const {
      bordered: d,
      mergedIconPlacement: c,
      cssVars: h,
      closable: x,
      showIcon: m,
      title: g,
      content: y,
      action: f,
      negativeText: R,
      positiveText: u,
      positiveButtonProps: v,
      negativeButtonProps: s,
      handlePositiveClick: t,
      handleNegativeClick: i,
      mergedTheme: r,
      loading: p,
      type: C,
      mergedClsPrefix: e
    } = this;
    (n = this.onRender) === null || n === void 0 || n.call(this);
    const b = m ? o(Y, {
      clsPrefix: e,
      class: `${e}-dialog__icon`
    }, {
      default: () => z(this.$slots.icon, (l) => l || (this.icon ? a(this.icon) : ae[this.type]()))
    }) : null, $ = z(this.$slots.action, (l) => l || u || R || f ? o("div", {
      class: [`${e}-dialog__action`, this.actionClass],
      style: this.actionStyle
    }, l || (f ? [a(f)] : [this.negativeText && o(S, Object.assign({
      theme: r.peers.Button,
      themeOverrides: r.peerOverrides.Button,
      ghost: !0,
      size: "small",
      onClick: i
    }, s), {
      default: () => a(this.negativeText)
    }), this.positiveText && o(S, Object.assign({
      theme: r.peers.Button,
      themeOverrides: r.peerOverrides.Button,
      size: "small",
      type: C === "default" ? "primary" : C,
      disabled: p,
      loading: p,
      onClick: t
    }, v), {
      default: () => a(this.positiveText)
    })])) : null);
    return o("div", {
      class: [`${e}-dialog`, this.themeClass, this.closable && `${e}-dialog--closable`, `${e}-dialog--icon-${c}`, d && `${e}-dialog--bordered`, this.rtlEnabled && `${e}-dialog--rtl`],
      style: h,
      role: "dialog"
    }, x ? z(this.$slots.close, (l) => {
      const P = [`${e}-dialog__close`, this.rtlEnabled && `${e}-dialog--rtl`];
      return l ? o("div", {
        class: P
      }, l) : o(Z, {
        clsPrefix: e,
        class: P,
        onClick: this.handleCloseClick
      });
    }) : null, m && c === "top" ? o("div", {
      class: `${e}-dialog-icon-container`
    }, b) : null, o("div", {
      class: [`${e}-dialog__title`, this.titleClass],
      style: this.titleStyle
    }, m && c === "left" ? b : null, T(this.$slots.header, () => [a(g)])), o("div", {
      class: [`${e}-dialog__content`, $ ? "" : `${e}-dialog__content--last`, this.contentClass],
      style: this.contentStyle
    }, T(this.$slots.default, () => [a(y)])), $);
  }
});
export {
  Se as NDialog
};
